import AddWorkApis from '../../apis/addWork';
import { CATEGORIES, HIDE_TOAST, OBJECTIVES, WORK_REQUIREMENT, OBJECTIVE_BY_ID } from '../../types';
import { signOut } from '../auth';
import { showToast } from '../toast';

import { ERROR_MSG, ERROR_MSG_401 } from '../../../constants';

export const getCategories = () => (dispatch, getstate) => {
  const state = getstate();
  const user = state.currentUser.data;

  if (!user) {
    return;
  }

  const callApi = async () => {
    try {
      const res = await AddWorkApis.getCategories();

      if (res.status === 500) {
        throw res;
      }

      if (res.status === 401) {
        dispatch(showToast('error', ERROR_MSG_401));
        dispatch(signOut());
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch({ type: `${CATEGORIES}_success`, payload: res_data });
      }
    } catch (err) {
      const payload = err && err.message ? err : { message: ERROR_MSG };

      dispatch({ type: `${CATEGORIES}_failed`, payload });
    }
  };

  dispatch({ type: `${CATEGORIES}_started` });

  return Promise.resolve(callApi());
};

export const getObjectives = (payload) => (dispatch) => {
  const callApi = async () => {
    try {
      const res = await AddWorkApis.getObjectives(payload);

      if (res.status === 500) {
        throw res;
      }

      if (res.status === 401) {
        dispatch(showToast('error', ERROR_MSG_401));
        dispatch(signOut());
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch({ type: `${OBJECTIVES}_success`, payload: res_data });
      }
    } catch (err) {
      const payload = err && err.message ? err : { message: ERROR_MSG };

      dispatch({ type: `${OBJECTIVES}_failed`, payload });
    }
  };

  dispatch({ type: `${HIDE_TOAST}` });

  return Promise.resolve(callApi());
};

export const getObjectiveById = (payload) => (dispatch) => {
  const callApi = async () => {
    try {
      const res = await AddWorkApis.getObjectiveById(payload);

      if (res.status === 500) {
        throw res;
      }

      if (res.status === 401) {
        dispatch(showToast('error', ERROR_MSG_401));
        dispatch(signOut());
      }

      const res_data = await res.json();

      if (!res.ok) {
        throw res_data;
      } else {
        dispatch({ type: `${OBJECTIVE_BY_ID}_success`, payload: res_data });
      }
    } catch (err) {
      const payload = err && err.message ? err : { message: ERROR_MSG };

      dispatch({ type: `${OBJECTIVE_BY_ID}_failed`, payload });
    }
  };

  dispatch({ type: `${HIDE_TOAST}` });

  return Promise.resolve(callApi());
};

export const createRequirement = (payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await AddWorkApis.createRequirement(payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${WORK_REQUIREMENT}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${WORK_REQUIREMENT}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const updateRequirement = (id, payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await AddWorkApis.updateRequirement(id, payload);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${WORK_REQUIREMENT}_success`, payload: res_data });
          dispatch(showToast('success', 'Progress Saved!'));

          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${WORK_REQUIREMENT}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const updateRequirementStatus = (id, event) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await AddWorkApis.updateRequirementStatus(id, event);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${WORK_REQUIREMENT}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${WORK_REQUIREMENT}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${HIDE_TOAST}` });

    return Promise.resolve(callApi());
  });

export const getRequirement = (id) => (dispatch) =>
  new Promise((resolve, reject) => {
    const callApi = async () => {
      try {
        const res = await AddWorkApis.getRequirement(id);

        if (res.status === 500) {
          throw res;
        }

        if (res.status === 401) {
          dispatch(showToast('error', ERROR_MSG_401));
          dispatch(signOut());
        }

        const res_data = await res.json();

        if (!res.ok) {
          throw res_data;
        } else {
          dispatch({ type: `${WORK_REQUIREMENT}_success`, payload: res_data });
          resolve(res_data);
        }
      } catch (err) {
        const payload = err && err.message ? err : { message: ERROR_MSG };

        dispatch({ type: `${WORK_REQUIREMENT}_failed`, payload });
        reject(err);
      }
    };

    dispatch({ type: `${WORK_REQUIREMENT}_started` });

    return Promise.resolve(callApi());
  });

export const resetWorkRequirement = () => (dispatch) => dispatch({ type: `${WORK_REQUIREMENT}_reset` });
